$(function() {
    const $backToTop = $('.back-to-top')

    $backToTop.on('click touch', () => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    })

    $(window).on('load resize scroll', () => {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            $backToTop.fadeIn()
        } else {
            $backToTop.fadeOut()
        }
    })
})